<script setup lang="ts">
  import { computed } from 'vue';
  import { NavigationItem } from '@/shared/lib';
  import { SelectInput } from '@/shared/ui';

  const ALL_MODULES_ID = '';

  interface Props {
    modules: NavigationItem[];
    selectedModules?: NavigationItem[];
    allModulesLabel?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    selectedModules: () => [],
    allModulesLabel: 'Todos os módulos',
  });

  const emit = defineEmits<{
    'modules-selected': [modules: NavigationItem[]];
  }>();

  const selectedModuleId = computed(() => {
    if (props.selectedModules.length === 1) {
      return props.selectedModules[0].id;
    }
    return ALL_MODULES_ID;
  });

  const moduleOptions = computed(() => [
    { id: ALL_MODULES_ID, name: props.allModulesLabel },
    ...props.modules.map((module) => ({
      id: module.id,
      name: module.name,
    })),
  ]);

  const handleModuleSelection = (moduleId: string | number) => {
    if (moduleId === ALL_MODULES_ID) {
      emit('modules-selected', []);
      return;
    }
    const selectedModule = props.modules.find((module) => module.id === moduleId);
    if (selectedModule) {
      emit('modules-selected', [selectedModule]);
    }
  };
</script>

<template>
  <SelectInput
    :model-value="selectedModuleId"
    :options="moduleOptions"
    :auto-select-first="false"
    class="shadow rounded-lg"
    @update:model-value="handleModuleSelection"
  />
</template>
